'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import { fetchSkillsAndKnowledges } from '../utils/fetch-skills-and-knowledges';

export const useSkillsSidebar = () => {
  const { client } = useApi();

  return useSWR('skill-quark-sidebar', async () => {
    const {
      data: { session },
    } = await client.auth.getSession();

    if (!session) {
      throw new Error('');
    }

    return fetchSkillsAndKnowledges(client, session.user.id);
  });
};
